import PropTypes from "prop-types";
// material
import { Box } from "@mui/material";
import logo from "../images/oxygen7-logo.png";
import logoWhite from "../images/oxygen7-logo-white.png";

// ----------------------------------------------------------------------

// Horizontal masterbrand logo. Use `inverse` on dark or coloured backgrounds.
const Logo = ({ sx, inverse }) => {
    return (
        <Box
            component="img"
            src={inverse ? logoWhite : logo}
            alt="Oxygen7"
            sx={{ width: 180, height: 75,marginLeft: 2, objectFit: "contain", ...sx }}
        />
    );
};

Logo.propTypes = {
    sx: PropTypes.object,
    inverse: PropTypes.bool,
};

export default Logo;
